import { useInfiniteQuery } from "@tanstack/react-query";
import { authorizationService } from "../services/authorizationService";

export const useAuthorizations = (search?: string) => {
  return useInfiniteQuery({
    queryKey: ["authorizations", search],
    initialPageParam: 0,

    queryFn: ({ pageParam }) =>
      authorizationService.getAuthorization({
        skip: pageParam,
        limit: 30,
        search: search || undefined,
      }),

    getNextPageParam: (lastPage) => {
      const nextSkip = lastPage.pagination.skip + lastPage.pagination.limit;

      if (nextSkip >= lastPage.pagination.total) {
        return undefined;
      }

      return nextSkip;
    },
  });
};
